import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../../modules/jobFunctions/jobNoteActions'
import * as api from '../../api/job/notes'

function* notesRefresh(action) {
  try {
    const payload = yield call(api.getJobNotes, action.jobId)
    yield put({ type: constants.NOTES_REFRESH.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.NOTES_REFRESH.FAILED,
      message: e.message || e
    })
  }
}

function* watchNotes() {
  yield takeLatest(constants.NOTES_REFRESH.ACTION, notesRefresh)
}

function* sagaCreateNote(action) {
  try {
    const payload = {
      job_id: action.jobId,
      content: action.content,
      created_by_id: action.userId,
      updated_by_id: action.userId
    }
    yield call(api.createNote, payload)
    yield put({ type: constants.NOTE_CREATE.SUCCESS, payload })
    yield call(notesRefresh, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.NOTE_CREATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchCreateNote() {
  yield takeLatest(constants.NOTE_CREATE.ACTION, sagaCreateNote)
}

function* sagaUpdateNote(action) {
  try {
    const payload = {
      job_id: action.jobId,
      note_id: action.noteId,
      content: action.content,
      updated_by_id: action.userId
    }
    yield call(api.updateNote, payload)
    yield put({ type: constants.NOTE_UPDATE.SUCCESS, payload })
    yield call(notesRefresh, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.NOTE_UPDATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchUpdateNote() {
  yield takeLatest(constants.NOTE_UPDATE.ACTION, sagaUpdateNote)
}

function* sagaDeleteNote(action) {
  try {
    const payload = {
      note_id: action.noteId
    }
    yield call(api.deleteNote, payload)
    yield put({ type: constants.NOTE_DELETE.SUCCESS, payload })
    yield call(notesRefresh, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.NOTE_DELETE.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteNote() {
  yield takeLatest(constants.NOTE_DELETE.ACTION, sagaDeleteNote)
}

// notes
function* fetchScheduleNote(action) {
  try {
    const scheduleNotes = yield call(api.fetchScheduleNote, {
      jobId: action.jobId
    })
    yield put({ type: constants.GET_SCHEDULE_NOTE.SUCCESS, scheduleNotes })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_SCHEDULE_NOTE.FAILED,
      message: e.message || e
    })
  }
}

function* watchFetchScheduleNote() {
  yield takeLatest(constants.GET_SCHEDULE_NOTE.ACTION, fetchScheduleNote)
}

function* createScheduleNote(action) {
  try {
    const payload = {
      content: action.content,
      jobId: action.jobId
    }
    yield call(api.createScheduleNote, payload)
    yield put({ type: constants.CREATE_SCHEDULE_NOTE.SUCCESS, payload })
    yield call(fetchScheduleNote, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.CREATE_SCHEDULE_NOTE.FAILED,
      message: e.message || e
    })
  }
}

function* watchCreateScheduleNote() {
  yield takeLatest(constants.CREATE_SCHEDULE_NOTE.ACTION, createScheduleNote)
}

function* editScheduleNote(action) {
  try {
    const payload = {
      content: action.content,
      noteId: action.noteId
    }
    yield call(api.editScheduleNote, payload)
    yield put({ type: constants.EDIT_SCHEDULE_NOTE.SUCCESS, payload })
    yield call(fetchScheduleNote, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.EDIT_SCHEDULE_NOTE.FAILED,
      message: e.message || e
    })
  }
}

function* watchEditScheduleNote() {
  yield takeLatest(constants.EDIT_SCHEDULE_NOTE.ACTION, editScheduleNote)
}

function* deleteScheduleNote(action) {
  try {
    const payload = {
      noteId: action.noteId
    }
    yield call(api.deleteScheduleNote, payload)
    yield put({ type: constants.DELETE_SCHEDULE_NOTE.SUCCESS, payload })
    yield call(fetchScheduleNote, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.DELETE_SCHEDULE_NOTE.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteScheduleNote() {
  yield takeLatest(constants.DELETE_SCHEDULE_NOTE.ACTION, deleteScheduleNote)
}

/**
 * Export the root saga by forking all available sagas.
 */
export function* rootSaga() {
  // add more sagas here
  yield all([
    fork(watchNotes),
    fork(watchCreateNote),
    fork(watchUpdateNote),
    fork(watchDeleteNote),

    //notes
    fork(watchFetchScheduleNote),
    fork(watchCreateScheduleNote),
    fork(watchEditScheduleNote),
    fork(watchDeleteScheduleNote)
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/jobFunctions/jobNoteSaga.js